import { render, staticRenderFns } from "./IrregularityDetailsInfo.vue?vue&type=template&id=461ae6d0&scoped=true"
import script from "./IrregularityDetailsInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./IrregularityDetailsInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IrregularityDetailsInfo.vue?vue&type=style&index=0&id=461ae6d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461ae6d0",
  null
  
)

export default component.exports